var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtendedSummer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OUTLINE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.65,34h12.7L39.7,23,33.35,12H20.65L14.3,23ZM37.39,23,32.2,32H21.8L32.2,14h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 22,
    width: 10,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 22,
    width: 10,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 4.68,
    width: 10,
    height: 2,
    transform: "translate(13.58 34.88) rotate(-60.01)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 39.32,
    width: 10,
    height: 2,
    transform: "translate(-26.42 34.89) rotate(-60.01)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 0.68,
    width: 2,
    height: 10,
    transform: "translate(-0.56 9.26) rotate(-30)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 35.32,
    width: 2,
    height: 10,
    transform: "translate(-15.2 23.9) rotate(-29.99)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendedSummer);
export default __webpack_public_path__ + "static/media/extended-summer.2c1c8680b598965f73788ed0acd72d79.svg";
export { ForwardRef as ReactComponent };